<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-select
        v-model="query.fState"
        style="width: 120px"
        size="small"
        clearable
      >
        <el-option value="未提交">未提交</el-option>
        <el-option value="已提交">已提交</el-option>
      </el-select>
      <el-input
        v-model="query.fBillNo"
        placeholder="订单编号"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fCkBillNo"
        placeholder="送货单号"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fDistributor"
        placeholder="经销商"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fCustomer"
        placeholder="客户名称"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fName_sh"
        placeholder="收货人"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-date-picker
        v-model="query.fDate"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="订单时间"
        size="small"
        style="width: 130px"
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="printing"
        style="background: cornflowerblue; color: white"
        @click="batchPrint"
      >批量打印<span v-if="printing">中...</span></el-button>
      <el-button-export :url="downloadUrl" type="primary" size="small">导出</el-button-export>

    </div>
    <div style="flex: auto; display: flex; flex-direction: column;overflow: auto">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        @row-dblclick="_view"
        @select="rowSelect"
        @select-all="rowSelect"
      >
        <el-table-column type="selection" width="50" />
        <el-table-column prop="printCount" label="打印数" width="70" />
        <el-table-column prop="fCkBillNo" label="送货单编号" width="140px" />
        <el-table-column prop="fBillNo" label="订单编号" width="140px" />
        <el-table-column prop="fState" label="单据状态" width="80px" />
        <el-table-column prop="fDistributor" label="经销商" min-width="160px" />
        <el-table-column prop="fCustomer" label="客户名称" min-width="160px" />
        <el-table-column prop="fName_sh" label="收货人" width="80px" />
        <el-table-column prop="fAmount" label="总金额" width="100px" />
        <el-table-column prop="fDate" label="订单时间" width="100px" />
        <el-table-column prop="fPhone" label="电话" width="120px" />
        <el-table-column prop="fAddress_sh" label="地址" min-width="160px" />
        <el-table-column label="操作" width="50px">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="_view(scope.row)"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <iframe
        style="display: none"
      ><BatchPrint id="printVoucher" ref="printVoucher"></BatchPrint
        ></iframe>
    </div>

    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import BatchPrint from '../commonPrint/batchPrint.vue'
import printnb from '@plugins/vue-print-nb-printarea'

export default {
  components: { BatchPrint },
  data() {
    return {
      query: {
        fState: '未提交',
        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,
      printing: false,
      tableData: [],
      loading: false,
      currentEditItem: null
    }
  },
  mounted() {
    // this.refresh();
  },
  activated() {
    // if (this.$route.query.isrefresh == "yes") this.refresh();
    // this.$route.query.isrefresh = null;
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('BusinessManage/Delivery/DeliveryEntry', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
      this.currentEditItem = null
    },
    _view: async function(row) {
      const readonly = await this.$httpPost('OrderManage/GetBillState', {
        fid: row.fid,
        key: 'DeliveryNote_ck'
      }).then((res) => res.datalist)
      var url = this.$route.path + '/' + (readonly ? 'v/' : '') + row.fid
      this.$router.push(url)
    },
    batchPrint: function() {
      this.printing = true
      // console.log(this.currentEditItem, "currentEditItem");
      this.$httpPost('BusinessManage/DeliveryForJxs/DeliveryBatchPrint1', {
        datalist: JSON.stringify({ idList: this.currentEditItem })
      })
        .then(async(res) => {
          // console.log(res, 'res')
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          const success = await this.$refs.printVoucher.refresh(res)
          if (success) {
            this.printing = false
            return
          }
          // https://www.npmjs.com/package/vue-print-nb
          new printnb({
            ids: 'printVoucher', // * 局部打印必传入id
            standard: '', // 文档类型，默认是html5，可选 html5，loose，strict
            extraHead: '', // 附加在head标签上的额外标签,使用逗号分隔
            extraCss: '', // 额外的css连接，多个逗号分开
            popTitle: '', // title的标题
            endCallback() {
              // 调用打印之后的回调事件
            }
          })
          setTimeout(() => {
            this.printing = false
          }, 100)
        })
        .finally(() => (this.printing = false))
    },
    rowSelect(selction) {
      this.currentEditItem = selction.map((v) => {
        return v.fid
      })
    },
    downloadUrl: function() {
      return this.$buildDownloadUrl(
        'Download/DeliveryCkDownload',
        this.queryParam(true)
      )
    },
    queryParam: function(forExport) {
      var rtn = {
        ...this.query
      }
      if (forExport) {
        // if (rtn.startGroupNumber == "") rtn.startGroupNumber = null;
        // if (rtn.endGroupNumber == "") rtn.endGroupNumber = null;
        delete rtn.pageIndex
        delete rtn.pageSize
      }
      return rtn
    }
  }
}
</script>

